export type GuestCartItem = {
  productId: string;
  name: string;
  price: number;     // effective price after discount
  quantity: number;
  image: string;
  stock: number;
};

const CART_KEY = 'arkab_cart';

export function getGuestCart(): GuestCartItem[] {
  try {
    const raw = localStorage.getItem(CART_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function addToGuestCart(item: Omit<GuestCartItem, 'quantity'> & { quantity?: number }): GuestCartItem[] {
  const cart = getGuestCart();
  const existing = cart.find((c) => c.productId === item.productId);
  if (existing) {
    const newQty = Math.min(existing.quantity + (item.quantity ?? 1), existing.stock);
    existing.quantity = newQty;
  } else {
    cart.push({ ...item, quantity: item.quantity ?? 1 });
  }
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
  return cart;
}

export function updateGuestCartItem(productId: string, quantity: number): GuestCartItem[] {
  const cart = getGuestCart().map((c) =>
    c.productId === productId ? { ...c, quantity: Math.max(1, Math.min(quantity, c.stock)) } : c,
  );
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
  return cart;
}

export function removeFromGuestCart(productId: string): GuestCartItem[] {
  const cart = getGuestCart().filter((c) => c.productId !== productId);
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
  return cart;
}

export function clearGuestCart(): void {
  localStorage.removeItem(CART_KEY);
}

export function getGuestCartCount(): number {
  return getGuestCart().reduce((sum, c) => sum + c.quantity, 0);
}

export function getGuestCartTotal(): number {
  return getGuestCart().reduce((sum, c) => sum + c.price * c.quantity, 0);
}
